// extracted by mini-css-extract-plugin
export default {"form":"form__Atqqt","row":"row__px9CL","label":"label__NJ1ga","labelText":"labelText__EVzYs","textInput":"textInput__Sp0Qg"};